import { Injectable } from '@angular/core';
import { Driver } from 'app/models/driver.model';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { User } from 'app/models/user.model';
import { UserService } from '../users/user.service';
import { Enterprise } from 'app/models/enterprise.model';

@Injectable({
  providedIn: 'root'
})
export class DriverService {

  apiUrl: string = `${environment.apiUrl}driver`;
  constructor(private client: HttpClient, private userService: UserService) { }

  async getDrivers(){
    let enterprise: User = JSON.parse(sessionStorage.getItem('loggedUser'));
    console.log('enterprise ', enterprise);
    return await this.client.get<Driver[]>(this.apiUrl + `?enterpriseId=${enterprise.databaseId}`).toPromise();
  }

  getDriver(id: number){
    // get one driver
  }    

  saveDriver(driver: Driver){
    try {
      if(driver.id){
        console.log('Actualizar conductor');
        return this.client.put<Driver>(this.apiUrl, driver).pipe(
          catchError(this.handleError)
        );
      }else{
        console.log('Guardar nuevo conductor');
        return this.client.post<Driver>(this.apiUrl, driver).pipe(
          catchError(this.handleError)
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // Return an observable with a user-facing error message.
    return throwError(
      'Something bad happened; please try again later.');
  }
}
